"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    fill: "#004864"
  }, props), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "11.78",
    cy: "8.41",
    r: "6.61",
    fill: "#ffffff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.88,11.88A3.88,3.88,0,1,1,15.77,8,3.88,3.88,0,0,1,11.88,11.88ZM11.88,0a8,8,0,0,0-8,8c0,4.24,7.28,15.31,7.59,15.78a.5.5,0,0,0,.83,0c.31-.47,7.58-11.54,7.58-15.78A8,8,0,0,0,11.88,0Z"
  }));
};

exports["default"] = _default;